import { trackByHref } from '../..';

// 页面路径映射表
const pageConf = [
    {
        path: '/new/tqcz/index.html',
        pageType_pvar: '列表页',
        pageName_pvar: '充值详情页',
        pageThirdGroup_pvar: '平台',
    },
    {
        path: '/new/tqcz/pay/pay.html',
        pageType_pvar: '确认页',
        pageName_pvar: '特权充值确认页',
        pageThirdGroup_pvar: '平台',
    },
    {
        path: '/new/tqcz/pay/detail.html',
        pageType_pvar: '待支付页',
        pageName_pvar: '特权充值待支付页',
        pageThirdGroup_pvar: '平台',
    },
    {
        path: '/new/tqcz/finish/finish.html',
        pageType_pvar: '完成页',
        pageName_pvar: '特权充值完成页',
        pageThirdGroup_pvar: '平台',
    },
    {
        path: '/new/tqcz/v2/index.html',
        pageType_pvar: '列表页',
        pageName_pvar: '充值详情页',
        pageThirdGroup_pvar: '平台',
    },
    {
        path: '/new/tqcz/pay/v2/pay.html',
        pageType_pvar: '确认页',
        pageName_pvar: '特权充值确认页',
        pageThirdGroup_pvar: '平台',
    },
    {
        path: '/new/tqcz/finish/v2/finish.html',
        pageType_pvar: '完成页',
        pageName_pvar: '特权充值完成页',
        pageThirdGroup_pvar: '平台',
    },
];

trackByHref(pageConf);
